import type { SVGProps } from "react";
import * as React from "react";
const SvgZendeskWhite = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#fff"
      d="M13 4v12L23 4H13ZM6 9a5 5 0 0 1-5-5h10a5 5 0 0 1-5 5ZM18 15a5 5 0 0 1 5 5H13a5 5 0 0 1 5-5ZM11 8v12H1L11 8Z"
    />
  </svg>
);
export default SvgZendeskWhite;
